<template>
    <!-- 课程信息 -->
    <div>
        <div class="conditionSearchBox">
            <div class="conditionItem">
                <el-input v-model="params.condition.classname" placeholder="班级名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.name" placeholder="课程名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="classname" label="班级名称" align="center" min-width="200" key="classname" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="classcoursename" label="课程名称" align="center" width="150" key="classcoursename" show-overflow-tooltip></el-table-column>
            <el-table-column prop="score" label="课程学分" align="center" width="150" key="score"></el-table-column>
            <el-table-column prop="normalabcount" label="已上课/排课数" align="center" width="150" key="normalabcount">
                <template slot-scope="scope">
                    <p>{{scope.row.normalabcount + '/' + scope.row.totalabcount}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="statusname" label="结业状态" align="center" width="100" key="statusname"></el-table-column>
            <el-table-column prop="recentexamscore" label="结业分值" align="center" width="100" key="recentexamscore"></el-table-column>
            <el-table-column prop="recentexamtime" label="结业时间" align="center" width="200" key="recentexamtime" :formatter="formatTab"></el-table-column>
            <el-table-column prop="finalscore" label="结业学分" align="center" width="100" key="finalscore"></el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import { getStudentCourseList } from '@/api/measApi/studentManage.js'
export default {
  data() {
    return {
      params: {
        condition: {
          classcode: '',
          classname: '',
          name: '',
          studentcode: ''
        },
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      contentLoading: false,
      tableData: [],
      total: 0,
      isSelect: false
    }
  },
  props: {
    code: {
      type: String,
      required: true
    },
    classCode: {
        type: String
    }
  },
  components: {
    TableSort,
    Page
  },
  created() {
    this.params.condition.studentcode = this.code
    this.params.condition.classcode = this.classCode || ''
    this.$nextTick(() => {
        this.getStudentCourseList()
    })
  },
  methods: {
    //   获取班级列表
    getStudentCourseList() {
      this.contentLoading = true
      getStudentCourseList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getStudentCourseList()
    },
    // 重置
    reset() {
      this.params = {
        condition: {
          classcode: '',
          classname: '',
          name: '',
          studentcode: this.code
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getStudentCourseList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getStudentCourseList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getStudentCourseList()
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    }
  }
}
</script>
